import PersonaSurveyModalModule from './persona-survey-modal.module'

export default PersonaSurveyModalModule
